import { Navigate, useRoutes } from "react-router-dom";
import Home from "../pages/home/Home";
import CreateEventCard from "../pages/home/CreateEventCard";
import RequestService from "../pages/home/RequestService";
import SportCard from "../pages/cards/SportCard";
import ClubCard from "../pages/cards/ClubCard";
import CrewCard from "../pages/cards/CrewCard";
import Community from "../pages/community/Community";
import ChatScreen from "../pages/community/ChatScreen";
import LoginPage from "../component/auth/Login";
import Signup from "../component/auth/Signup";
import ForgotPassword from "../component/auth/ForgotPassword.js";
import PlayerDescription from "../pages/community/PlayerDescription";
// layouts
import AuthLayout from "../layout/authLayout";
import DashboardLayout from "../layout/dashboardLayout";
import ProtectedRoute from "../authService/ProtectedRoute";
import ResetPassword from "../component/auth/ResetPassword.js";
import Rating from "../pages/profile/rating";
import VenueOperations from "pages/profile/venueOperations";
import EditProfile from "pages/profile/profileEdit";
import BookingHistory from "pages/profile/bookingHistory";
import PurchaseDetail from "pages/profile/bookingHistory/purchaseDetail";
import ChangePassword from "component/auth/ChangePassword";
import ArenaDetails from "pages/profile/venueOperations/arenaDetails";
import PaymentMethods from "pages/profile/paymentMethods";
import PaymentHistory from "pages/profile/paymentMethods/paymentHistory";
import PaymentHistoryDetail from "pages/profile/paymentMethods/paymentHistoryDetail";
import AddAccount from "pages/profile/paymentMethods/addAccount";
import Messages from "pages/messages";
import MyPosting from "pages/myPosting";
import CardDetails from "pages/myPosting/cardDetails";
import GameOn from "pages/home/GameOn";
import ClubService from "pages/home/ClubService";
import ClubMatch from "pages/home/ClubMatch";
import ClubVenue from "pages/home/ClubVenue";
import VenueCard from "pages/cards/VenueCard";
import AssignMatch from "pages/myPosting/assignMatch";
import RequestSent from "pages/myPosting/requestSent";

export default function Router() {
  const routes = useRoutes([
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <DashboardLayout />{" "}
        </ProtectedRoute>
      ),
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        { path: "/dashboard", element: <Home /> },
        { path: "/club/game-on", element: <GameOn /> },
        // { path: "/club/service", element: <ClubService /> },
        // { path: "/event/request-service", element: <ClubService /> },
        { path: "/club/match/:id", element: <ClubMatch /> },
        { path: "/club/venue", element: <ClubVenue /> },
        { path: "/cards/sport", element: <SportCard /> },
        { path: "/cards/crew", element: <CrewCard /> },
        { path: "/cards/club", element: <ClubCard /> },
        { path: "/cards/venue", element: <VenueCard /> },
        { path: "/event/card/:id", element: <CreateEventCard /> },
        { path: "/event/request-service/:id", element: <RequestService /> },
        // { path: "/cards/player", element: <PlayerDetail /> },
        // { path: "/cards/crew", element: <CrewDetail /> },
        // { path: "/cards/club", element: <ClubDetail /> },
        { path: "/community", element: <Community /> },
        { path: "/messages", element: <Messages /> },
        { path: "/my-posting", element: <MyPosting /> },
        { path: "/chat/:id", element: <ChatScreen /> },
        { path: "/rating", element: <Rating /> },
        { path: "/booking-history", element: <BookingHistory /> },
        { path: "/booking-history/:id", element: <PurchaseDetail /> },
        { path: "/venue-operations", element: <VenueOperations /> },
        { path: "/profile-edit", element: <EditProfile /> },
        { path: "/payment-methods", element: <PaymentMethods /> },
        { path: "/payment-history", element: <PaymentHistory /> },
        {
          path: "/payment-history/:id/details",
          element: <PaymentHistoryDetail />,
        },
        { path: "/payment-methods/addAccount", element: <AddAccount /> },
        { path: "/card-details/:type/:id", element: <CardDetails /> },

        {
          path: "/player-details/:id",
          element: <PlayerDescription />,
        },
        { path: "/arena-details/:venueId/:id", element: <ArenaDetails /> },
        { path: "/assign-match", element: <AssignMatch /> },
        { path: "/request-sent", element: <RequestSent /> },
      ],
    },
    {
      path: "/",
      element: <AuthLayout />,
      children: [
        { path: "login", element: <LoginPage /> },
        { path: "signup", element: <Signup /> },
        { path: "forgot-password", element: <ForgotPassword /> },
        { path: "resetPassword", element: <ResetPassword /> },
        { path: "change-password", element: <ChangePassword /> },
      ],
    },
    // { path: "*", element: isLogin ? <Page404 /> : <Navigate to="/login" /> }
  ]);

  return routes;
}
